/**
 * O PLH RESPONSÁVEL DE UM CLIENTE — leitura única e direta.
 *
 * Desde 2026-09-24 a habilitação de PLH é decidida por
 * `Client.responsiblePlhProfessionalId` (seção 24). Os gates são puros e
 * síncronos: recebem o responsável já resolvido. Este helper é o pedacinho de
 * leitura que faltava, escrito uma vez para que nenhum módulo repita a regra
 * — que é exatamente o que o item 2 da seção 24 exige.
 *
 * Não valida nada: só responde "quem o Cliente nomeou". Quem decide se essa
 * pessoa pode aprovar é `isPlhQualifiedProfessional`.
 */
export interface ClientPlhLookupRepository {
  getClient(id: string): Promise<{ responsiblePlhProfessionalId?: string | null } | null>;
}

export async function responsiblePlhIdOfClient(
  repo: ClientPlhLookupRepository | null | undefined,
  clientId: string | null | undefined
): Promise<string | null> {
  if (!repo || !clientId) return null;
  try {
    const client = await repo.getClient(String(clientId));
    const responsible = client?.responsiblePlhProfessionalId;
    return responsible ? String(responsible) : null;
  } catch {
    // Cliente ilegível é ausência de responsável: o gate nega, como deve.
    return null;
  }
}
